module.exports = ":host {\n  color: #555;\n  display: block;\n  font-family: Arial;\n  padding-top: 200px;\n  text-align: center; }\n"